module.exports = __webpack_public_path__ + "static/img/img-01.b68e115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-01.jpg
// module id = wzAM
// module chunks = 1